const state = {
  userData: {
    language: null,
    password: null,
    rePassword: null,
    sms: true,
    phone: null,
    terms: false
  }
}

const getters = {
  userData(state) {
    return state.userData;
  },
}

const actions = {
  setFirstStep({commit}, language) {
    commit("setLanguage", language);
  },
  setSecondStep({commit}, data) {
    commit("setSms", data.sms);
    commit("setPhone", data.phone);
  },
  setThirdStep({commit}, data) {
    commit("setPassword", {password: data.password, rePassword: data.rePassword});
    commit("setTerms", data.terms);
  },
}

const mutations = {
  setLanguage(state, language) {
    state.userData.language = language;
  },
  setSms(state, sms) {
    state.userData.sms = sms;
  },
  setPhone(state, phone) {
    state.userData.phone = phone;
  },
  setPassword(state, passwords) {
    state.userData.password = passwords.password;
    state.userData.rePassword = passwords.rePassword;
  },
  setTerms(state, terms) {
    state.userData.terms = terms;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
